import {
    Box,
    Button,
    Container,
    FormControl,
    Grid,
    MenuItem,
    Select,
    TextField,
    Stack,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

const AGENTS = {
    booking: {
        id: "agent_458edc8eb0dda683815e9aee9c",
        label: "Appointment Booking Agent",
        leadType: "wfs_appointment_booking",
    },
    booking_optimized: {
        id: "agent_469b04e6418345395f89eef521",
        label: "Appointment Booking Agent (Optimized)",
        leadType: "wfs_appointment_booking",
    },
    confirmation: {
        id: "agent_8dcb8e44608a38802eb37fb068",
        label: "Appointment Confirmation Agent",
        leadType: "wfs_appointment_confirmation",
    },
};

const CURRENT_SITUATION_OPTIONS = [
    { value: "Business Owner", label: "Business Owner" },
    { value: "Incorporated Professional", label: "Incorporated Professional" },
];

const TRAPPED_CAPITAL_OPTIONS = [
    { value: "$100K - $500K", label: "$100K - $500K" },
    { value: "$500K - $1M", label: "$500K - $1M" },
    { value: "$1M - $2.5M", label: "$1M - $2.5M" },
    { value: "$2.5M - $5M", label: "$2.5M - $5M" },
    { value: "$5M+", label: "$5M+" },
];

// Default appointment datetime: August 8th, 2026 at 10:00 AM local time
// datetime-local input expects format "YYYY-MM-DDTHH:MM" in local time
const DEFAULT_APPOINTMENT_DATETIME = "2026-08-08T10:00";

export const WFSDemo = () => {
    const [country, setCountry] = useState("ca");
    const [selectedAgent, setSelectedAgent] = useState("confirmation");
    const [testV2FirstName, setTestV2FirstName] = useState("");
    const [testV2PhoneNumber, setTestV2PhoneNumber] = useState("");
    const [testV2Email, setTestV2Email] = useState("");
    const [testV2LastName, setTestV2LastName] = useState("");
    
    // Confirmation agent specific fields
    const [leadGhlContactId, setLeadGhlContactId] = useState("");
    const [appointmentDateTime, setAppointmentDateTime] = useState(DEFAULT_APPOINTMENT_DATETIME);
    const [currentSituation, setCurrentSituation] = useState("Business Owner");
    const [trappedCapital, setTrappedCapital] = useState("$100K - $500K");

    const handleSubmit = async (event) => {
        event.preventDefault();

        const fromNumber = "12392081459";
        const baseUrl =
            "https://initiate-retell-call-7blmr5azyq-uc.a.run.app";
        let agent_id = AGENTS[selectedAgent].id;
        let lead_first_name = testV2FirstName;
        let lead_type = AGENTS[selectedAgent].leadType;
        let to_number = testV2PhoneNumber;
        let facebook_ad_tagline = "10 million dollar wealth plan";
        let lead_email = testV2Email;
        let lead_full_name = `${testV2FirstName} ${testV2LastName}`;
        let human_agent_id = "zJL49bF390uhsUdJ5B6M";
        let lead_id = "8vCks0BHgvNhWZBvHWh9";
        let human_agent_company_name = "Northgate Financial";

        // Build base URL with common parameters
        let requestUrl = `${baseUrl}?lead_full_name=${encodeURIComponent(lead_full_name)}&lead_first_name=${encodeURIComponent(lead_first_name)}&from_number=${fromNumber}&agent_id=${agent_id}&to_number=+${to_number}&lead_id=${lead_id}&lead_type=${lead_type}&facebook_ad_tagline=${encodeURIComponent(facebook_ad_tagline)}&lead_email=${encodeURIComponent(lead_email)}&human_agent_id=${human_agent_id}&human_agent_company_name=${encodeURIComponent(human_agent_company_name)}`;

        // Add dynamic variables for both booking and confirmation agents
        requestUrl += `&lead_ghl_contact_id=${encodeURIComponent(leadGhlContactId)}&current_situation=${encodeURIComponent(currentSituation)}&trapped_capital=${encodeURIComponent(trappedCapital)}`;

        // Add confirmation agent specific parameters (appointment_datetime only)
        if (selectedAgent === "confirmation") {
            const appointmentDateTimeISO = new Date(appointmentDateTime).toISOString();
            requestUrl += `&appointment_datetime=${encodeURIComponent(appointmentDateTimeISO)}`;
        }

        await axios
            .request(requestUrl, {
                method: "GET",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                },
            })
            .then((res) => window.alert("Call initiated successfully!"));
    };

    return (
        <div className="full-page-background">
            <Grid item xs={12} md={7}>
                <Container className="App" maxWidth="sm">
                    <img src={logo} className="App-logo" alt="logo" />
                    <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                        <h1 style={{
                            color: '#FFFFFF',
                            fontSize: '2rem',
                            fontWeight: 'bold',
                            margin: '1rem',
                        }}>
                            WFS DEMO
                        </h1>
                        <div style={{
                            height: '4px',
                            width: '100px',
                            background: 'linear-gradient(90deg, #a0b8ff, #8a2be2)',
                            margin: '0 auto',
                            borderRadius: '2px'
                        }}></div>
                    </div>
                    <h3 style={{
                        textAlign: 'center',
                        color: '#d0d0d0',
                        fontWeight: '400',
                        fontSize: '16px',
                        lineHeight: '1.6',
                        maxWidth: '500px',
                        margin: '0 auto 1.5rem auto'
                    }}>
                        Northgate Financial 10M Wealth Plan
                    </h3>
                    <form onSubmit={handleSubmit}>
                        <Stack spacing={2}>
                            <FormControl fullWidth>
                                <Select
                                    value={selectedAgent}
                                    onChange={(e) => setSelectedAgent(e.target.value)}
                                    sx={{
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        height: "56px",
                                        textAlign: "left",
                                        '& .MuiSelect-select': {
                                            textAlign: "left",
                                        }
                                    }}
                                >
                                    <MenuItem value="booking">{AGENTS.booking.label}</MenuItem>
                                    <MenuItem value="booking_optimized">{AGENTS.booking_optimized.label}</MenuItem>
                                    <MenuItem value="confirmation">{AGENTS.confirmation.label}</MenuItem>
                                </Select>
                            </FormControl>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <TextField
                                    autoFocus
                                    label="First Name"
                                    variant="filled"
                                    sx={{
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                    }}
                                    fullWidth
                                    value={testV2FirstName}
                                    onChange={(e) => setTestV2FirstName(e.target.value)}
                                    required
                                />
                                <TextField
                                    label="Last Name"
                                    variant="filled"
                                    sx={{
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                    }}
                                    fullWidth
                                    value={testV2LastName}
                                    onChange={(e) => setTestV2LastName(e.target.value)}
                                    required
                                />
                            </Stack>
                            <TextField
                                label="Email"
                                variant="filled"
                                sx={{
                                    backgroundColor: "white",
                                    borderRadius: "4px",
                                }}
                                fullWidth
                                value={testV2Email}
                                onChange={(e) => setTestV2Email(e.target.value)}
                                required
                            />
                            <>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        label="GHL Contact ID"
                                        variant="filled"
                                        sx={{
                                            backgroundColor: "white",
                                            borderRadius: "4px",
                                        }}
                                        fullWidth
                                        value={leadGhlContactId}
                                        onChange={(e) => setLeadGhlContactId(e.target.value)}
                                    />
                                    <TextField
                                        label="Trapped Capital"
                                        select
                                        variant="filled"
                                        sx={{
                                            backgroundColor: "white",
                                            borderRadius: "4px",
                                        }}
                                        fullWidth
                                        value={trappedCapital}
                                        onChange={(e) => setTrappedCapital(e.target.value)}
                                    >
                                        {TRAPPED_CAPITAL_OPTIONS.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Stack>
                                <FormControl fullWidth>
                                    <Select
                                        value={currentSituation}
                                        onChange={(e) => setCurrentSituation(e.target.value)}
                                        sx={{
                                            backgroundColor: "white",
                                            borderRadius: "4px",
                                            height: "56px",
                                            textAlign: "left",
                                            '& .MuiSelect-select': {
                                                textAlign: "left",
                                            }
                                        }}
                                    >
                                        {CURRENT_SITUATION_OPTIONS.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {selectedAgent === "confirmation" && (
                                    <TextField
                                        label="Appointment Date & Time"
                                        type="datetime-local"
                                        variant="filled"
                                        sx={{
                                            backgroundColor: "white",
                                            borderRadius: "4px",
                                        }}
                                        fullWidth
                                        value={appointmentDateTime}
                                        onChange={(e) => setAppointmentDateTime(e.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                )}
                            </>
                            <h3 style={{
                                color: '#FFFFFF',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                margin: '16px 0 0 0',
                                textAlign: 'left'
                            }}>
                                Your Number
                            </h3>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                                <FormControl sx={{ minWidth: { xs: '100%', sm: '150px' } }}>
                                    <Select
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                        sx={{
                                            backgroundColor: "white",
                                            borderRadius: "4px",
                                            height: "56px",
                                        }}
                                        required
                                    >
                                        <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                                        <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                                        <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                                    </Select>
                                </FormControl>
                                <Box sx={{ flex: { sm: '1' }, width: '100%' }}>
                                    <PhoneInput
                                        country={country}
                                        value={testV2PhoneNumber}
                                        disableDropdown={true}
                                        disableCountryGuess={true}
                                        onChange={setTestV2PhoneNumber}
                                        enableLongNumbers={true}
                                        placeholder="Enter your phone number"
                                        inputStyle={{
                                            width: "100%",
                                            textAlign: "center",
                                            fontSize: "16px",
                                            height: "56px",
                                            borderRadius: "4px",
                                            border: "1px solid #ced4da",
                                        }}
                                        required
                                    />
                                </Box>
                            </Stack>
                            <Button
                                className="callBtn"
                                type="submit"
                                variant="contained"
                                fullWidth
                                sx={{
                                    background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
                                    boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                                    color: 'white',
                                    height: '56px',
                                    padding: '0 30px',
                                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
                                        background: 'linear-gradient(45deg, #1769aa 30%, #1e88e5 90%)',
                                    },
                                }}
                            >
                                <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>
                                    Click here to receive the DEMO call
                                </h2>
                                <div style={{ width: "20px" }} />
                                <Call className="callIcon" />
                            </Button>
                            <div style={{
                                backgroundColor: '#eaf2fa',
                                padding: '16px',
                                borderRadius: '8px',
                                border: '1px solid #d0e0f0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                            }}>
                                <span style={{ fontSize: '24px' }}>ℹ️</span>
                                <p style={{
                                    margin: 0,
                                    textAlign: 'left',
                                    color: '#333',
                                    lineHeight: '1.5',
                                    fontSize: '14px'
                                }}>
                                    After clicking to receive the DEMO call, you will receive a call from the following number:
                                    <b style={{ color: '#005a9c' }}> +1 (239) 208-1459</b>
                                </p>
                            </div>
                        </Stack>
                    </form>
                </Container>
            </Grid>
        </div>
    );
};
